import { ReducerPaths } from '$store/constants/reducerPaths';
import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/dist/query';
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export type SmartInterviewsBuilder = EndpointBuilder<
  BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError,
    {},
    FetchBaseQueryMeta
  >,
  'SmartInterviews' | 'SmartInterviewsVideos',
  ReducerPaths.SMART_INTERVIEWS
>;

export type GetAllSmartInterviewOutput = {
  Id?: number;
  Name: string;
  Description?: string;
  VoiceId?: string;
  Status?: string;
  IsActive?: boolean;
  CreateTime?: string;
  UpdateTime?: string;
}[];

export type UpdateSmartInterviewInput = {
  smartInterviewId: number;
  data: GetAllSmartInterviewOutput[number];
  disableUpdateVoice?: boolean;
};

export type CreateSmartInterviewInput = {
  Name: string;
  Description: string;
  WelcomeMessages: string[];
  Questions: string[];
};

export type GetOneSmartInterviewOutput = {
  Id?: number;
  Name: string;
  Description: string;
  WelcomeMessages: string[];
  Questions: string[];
  WelcomeAudio?: string[];
  QuestionsAudio?: string[];
  VoiceId?: string;
  Status?: string;
  IsActive?: boolean;
  CreateTime?: string;
  UpdateTime?: string;
};

export type GetOneSmartInterviewInput = {
  smartInterviewId: number;
};

export type GetCandidateSmartInterviewsVideosInput = {
  candidateId: number;
  status?: SmartInterviewVideoStatus;
};

export type GetCandidateSmartInterviewsVideosOutput = {
  Id: number;
  SmartInterviewQuestions: {
    Id: number;
    Name: string;
  } | null;
  Questions: string[];
  Metadata: {
    welcome: string;
  };
  Status: SmartInterviewVideoStatus;
  StartTime: string;
  EndTime: null | string;
  RawUrl: string;
  RawKey: string;
  Key: string;
  Url: string;
  CreateTime: string;
  UpdateTime: string;
  IsVisible: boolean;
}[];

export enum SmartInterviewVideoStatus {
  Created = 'Created',
  InProgress = 'In progress',
  Completed = 'Completed',
  Cancelled = 'Cancelled',
  Failed = 'Failed',
}

export type UpdateVisibilitySmartInterviewInput = {
  Id: number;
  IsVisible: boolean;
}[];
